import { useMutation, useQuery } from "@tanstack/react-query";
import { api, type EventPublic, type ParticipantSelf } from "@/lib/api";

export function usePublicEvent(shortcut: string) {
  return useQuery({
    queryKey: ["event-public", shortcut],
    queryFn: () => api.get<EventPublic>(`/api/v1/events/${shortcut}`),
    enabled: shortcut.length > 0,
    retry: false,
  });
}

export function useSelfRegister(shortcut: string) {
  return useMutation({
    mutationFn: (payload: { name: string; persons: number }) =>
      api.post<ParticipantSelf>(`/api/v1/events/${shortcut}/participants`, payload),
  });
}
